import {Pipe, PipeTransform} from '@angular/core';
import {Task} from '../entities/Task';

@Pipe({
  name: 'SearchPipe'
})
export class SearchPipe implements PipeTransform {
  transform(items: any[], str, field: string, sortReverse: boolean): any {
    if (str === undefined || str === '') {
      return items;
    }
    let filtered = [];

    //words = str.replace(" ", "|");
    str = str.trim();
    let words = str.replace(new RegExp(' ', 'g'), '|');
    //console.log(words);
    let rgx = new RegExp(words, 'gi');
    //console.log(rgx);
    let taskToTest = new Task();

    if (typeof items[0] == typeof taskToTest) {
      items.forEach(item => {
        taskToTest = item.valueOf();
          item.points = (JSON.stringify(item).match(rgx) || []).length;
          if (item.points > 0) {
            if ((taskToTest.Responsible.toLowerCase().includes(str.toLowerCase())) ||
              (taskToTest.Status.toLowerCase().includes(str.toLowerCase())) ||
              (taskToTest.JobNo.toLowerCase().includes(str.toLowerCase())) ||
              (taskToTest.To_Be_Done_By.toLowerCase().includes(str.toLowerCase()))||
              (taskToTest.No.toString().toLowerCase().includes(str.toLowerCase()))||
              (taskToTest.Job_Description.toLowerCase().includes(str.toLowerCase()))||
              (taskToTest.Text.toLowerCase().includes(str.toLowerCase()))||
              (taskToTest.Customer_Name.toLowerCase().includes(str.toLowerCase()))||
              (taskToTest.Job_Task_No.toString().toLowerCase().includes(str.toLowerCase()))) {
            filtered.push(item);
          }
        }
      });
    } else {
      items.forEach(item => {
        item.points = (JSON.stringify(item).match(rgx) || []).length;
        if (item.points > 0) {
          filtered.push(item);
        }
      });
    }


    if (sortReverse) {
      filtered.sort((a: any, b: any) => {
        if (a[field] < b[field]) {
          return -1;
        } else if (a[field] > b[field]) {
          return 1;
        } else {
          return 0;
        }
      });
    } else {
      filtered.sort((a: any, b: any) => {
        if (a[field] > b[field]) {
          return -1;
        } else if (a[field] < b[field]) {
          return 1;
        } else {
          return 0;
        }
      });
    }

    return filtered;
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/pipes/SearchPipe.ts